import {Button, Link} from "@amzn/awsui-components-react";
import React from "react";
import {ExternalReportState, ItemType, ReportDefinition, ReportStatus} from "src/common/report";
import Paths from "src/components/PageConfig/Paths";


//ItemType instead of report role 
export const hrefLink = (reportDefinition: ReportDefinition) => {
    const reportBuilderReportTypes = new Set(['SFPA', 'DC FPA'])

    if(reportDefinition.item_type == ItemType.External){
        return (reportDefinition as ExternalReportState).link;
    }

    if (reportBuilderReportTypes.has(reportDefinition.name_and_type?.report_type || '')) {
        const {workflow_id, workflow_version, execution_id} = reportDefinition;
        return `#/report-builder/reports/${reportDefinition.report_url_id}`;
    }

    return `#${Paths.VIEWREPORT}?report_id=${reportDefinition.report_id}`;
}

export const generateDisplayName = (
    reportDefinition: ReportDefinition,
    folderButtonProps: object = {},
    belongsToFolder = false,
    enableReportLinks: boolean
) => {
    const {report_status, item_type, name_and_type} = reportDefinition;
    if(item_type === ItemType.ReviewFolder) {
        return (<>
            <Button {...folderButtonProps}/>
            {name_and_type?.report_name}
        </>);
    } else {
        const href = hrefLink(reportDefinition)
        const linkProps = item_type === ItemType.External ? {target: "_blank", external: true} : {};
        const reportIsReady = report_status === ReportStatus.CREATED || report_status === ReportStatus.EDITED;
        const displayComponent = (
            <span style={{paddingLeft: belongsToFolder ? "28px" : "6px"}}>
                {name_and_type?.report_name}
            </span>
        );
        return (enableReportLinks && reportIsReady) ? <Link href={href} {...linkProps}>{displayComponent}</Link>
            : displayComponent;
    }
}